import React from "react";

const ImageRenderer = ({
  object,
  dataJson,
  styleJson,
  commonStyle,
  handleMouseDown,
  renderSelectionHandles,
}) => {
  const transparentBackground = dataJson.transparentBackground ?? true;

  const handleLocalMouseDown = (e) => {
    e.stopPropagation();
    handleMouseDown?.(e);
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onMouseDown={handleLocalMouseDown}
      style={{
        position: "absolute",
        ...commonStyle,
        backgroundColor: transparentBackground
          ? "transparent"
          : styleJson.backgroundColor || "#ffffff",
        outline: renderSelectionHandles() ? "2px solid #2563eb" : "none",
        outlineOffset: renderSelectionHandles() ? "2px" : "0",
      }}
    >
      <img
        src={dataJson.src || ""}
        alt={object.name || "image"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: dataJson.objectFit || "contain",
          display: "block",
          pointerEvents: "none",
          borderRadius: styleJson.borderRadius || 0,
        }}
      />
      {renderSelectionHandles()}
    </div>
  );
};

export default ImageRenderer;